import { render, staticRenderFns } from "./Body.vue?vue&type=template&id=4b14bcb8"
import script from "./Body.vue?vue&type=script&lang=ts"
export * from "./Body.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports